"use-strict";

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

var BlsAnimations = (function () {
  return {
    innit: function () {
      this.animates();
    },
    animates: function () {
      var animates = document.querySelectorAll(".scroll-trigger");
      if (animates.length > 0) {
        animates.forEach((i) => {
          i.addEventListener("animationend", (e) => {
            setTimeout(() => {
              e.target.setAttribute("animation-end", "");
            }, 1000);
          });
        });
      }
    },
  };
})();

let parser = new DOMParser();

const ON_CHANGE_DEBOUNCE_TIMER = 300;

function getSwiperLoopRequirement(
  slidesPerView,
  centeredSlides = false,
  slidesPerGroup = 1
) {
  if (slidesPerView === "auto") return null;
  let visibleSlides = Math.ceil(parseFloat(slidesPerView));
  if (!Number.isFinite(visibleSlides) || visibleSlides < 1) {
    visibleSlides = 1;
  }
  if (centeredSlides && visibleSlides % 2 === 0) {
    visibleSlides += 1;
  }
  let groupedSlides = Math.ceil(parseFloat(slidesPerGroup));
  if (!Number.isFinite(groupedSlides) || groupedSlides < 1) {
    groupedSlides = 1;
  }
  return visibleSlides + groupedSlides;
}

function canUseSwiperLoop(totalSlides, loopConfigs = [], rowCount = 1) {
  if (totalSlides <= 1) return false;
  if (Number(rowCount) > 1) return false;
  const requirements = loopConfigs
    .map(({ slidesPerView, centeredSlides = false, slidesPerGroup = 1 }) =>
      getSwiperLoopRequirement(slidesPerView, centeredSlides, slidesPerGroup)
    )
    .filter(Number.isFinite);
  if (requirements.length === 0) {
    return totalSlides > 1;
  }
  return totalSlides >= Math.max(...requirements);
}

function countSwiperSlides(container) {
  const wrapper = Array.from(container?.children || []).find((child) =>
    child.classList?.contains("swiper-wrapper")
  );
  if (!wrapper) return 0;
  return Array.from(wrapper.children).filter((child) =>
    child.classList?.contains("swiper-slide")
  ).length;
}

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
};

document.addEventListener("DOMContentLoaded", function () {
    const lazyImage = document.querySelectorAll(".image-lazy-load");
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
              const imgElement = entry.target;
              const imgSrcset = imgElement.dataset.srcset;
              if (!imgElement.classList.contains("optimize")) {
                if (imgSrcset) {
                    imgElement.setAttribute("srcset", imgSrcset);
                    imgElement.removeAttribute("data-srcset");
                    imgElement.classList.remove("image-lazy-load");
                    imgElement.classList.add("image-lazy-loaded");
                    if (imgElement.closest('.image-picture')) {
                      const imgPictureSrcset = imgElement.closest('.image-picture').querySelector("source").dataset.srcset;
                      if (imgPictureSrcset) {
                        imgElement.closest('.image-picture').querySelector("source").setAttribute("srcset", imgPictureSrcset);
                        imgElement.closest('.image-picture').querySelector("source").removeAttribute("data-srcset");
                      }
                    }
                    observer.unobserve(imgElement);
                }
              }
            }
        });
    }, {
        rootMargin: "50px"
    });
    lazyImage.forEach(imgElement => observer.observe(imgElement));
});

class SlideSection extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  init() {
    if (document.body.classList.contains("index")) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains("swiper-lazy")) {
        this.initSlide();
      } else {
        if (this.classList.contains("lazy-loading-swiper-before")) {
          this.initSlide();
        } else {
          this.classList.add("lazy-loading-swiper-after");
        }
      }
    } else {
      this.initSlide();
    }
    window.addEventListener("resize", this.setEqualHeight());
  }

  setEqualHeight() {
    const infoProduct = document.querySelectorAll(".testimonial_info > div");
    let maxHeight = 0;
    if (infoProduct.length > 0) {
      infoProduct.forEach((item) => {
        item.style.minHeight = '';
        const height = item.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      infoProduct.forEach((item) => {
        item.style.minHeight = `${maxHeight}px`;
      });
    }
  }

  initSlide() {
    const _this = this;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    var spacingMobile = _this?.dataset.spacingMobile ? _this?.dataset.spacingMobile : 15;

    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const freeMode = _this?.dataset.freeMode === "true";
    const grabCursor = _this?.dataset.grabCursor === "true";
    const mouseWheel = _this?.dataset.mouseWheel === "true";
    const slidesPerGroupRaw = _this?.dataset.slidesPerGroup
      ? _this?.dataset.slidesPerGroup
      : 1;
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    spacingMobile = Number(spacingMobile);
    autoplaySpeed = Number(autoplaySpeed);
    const typeSlide = _this?.dataset.typeSlide;
    speed = Number(speed);
    let slidesPerGroup = Number(slidesPerGroupRaw);
    if (!Number.isFinite(slidesPerGroup) || slidesPerGroup < 1) {
      slidesPerGroup = 1;
    }
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    const totalSlides = countSwiperSlides(_this);
    const enableLoop =
      loop &&
      canUseSwiperLoop(
        totalSlides,
        [
          {
            slidesPerView: autoItem ? "auto" : itemMobile,
            slidesPerGroup: slidesPerGroup,
          },
          {
            slidesPerView: itemTablet,
            slidesPerGroup: slidesPerGroup,
          },
          {
            slidesPerView: itemDesktop,
            slidesPerGroup: slidesPerGroup,
          },
        ],
        row
      );
    const requestSlideshowVideoPlay = (video) => {
      const playVideo = () => {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.play().catch(() => {});
      };

      if (video.readyState >= 2) {
        playVideo();
        return;
      }

      video.addEventListener("loadeddata", playVideo, { once: true });
      video.addEventListener("canplay", playVideo, { once: true });
    };
    const syncSlideshowVideos = () => {
      const videos = _this.querySelectorAll("video.slideshow");
      const isMobileViewport = window.innerWidth <= 767;
      const activeSlide = _this.querySelector(".swiper-slide-active");
      const firstSlide = _this.querySelector(".swiper-slide");
      videos.forEach((video) => {
        const posterDesktop = video.dataset.posterdesktop;
        const posterMobile = video.dataset.postermobile;
        const mediaTarget = video.dataset.mediaTarget;
        const slide = video.closest(".swiper-slide");
        const shouldLoadVideo =
          !mediaTarget ||
          (isMobileViewport ? mediaTarget === "mobile" : mediaTarget === "desktop");
        const shouldPlayVideo =
          shouldLoadVideo &&
          (!slide ||
            slide.classList.contains("swiper-slide-active") ||
            (!activeSlide && firstSlide && slide === firstSlide));

        if (posterDesktop && posterMobile) {
          video.poster = isMobileViewport ? posterMobile : posterDesktop;
        }

        if (!shouldLoadVideo) {
          video.pause();
          return;
        }

        const dataSrc = video.dataset.src;
        if (dataSrc && video.getAttribute("src") !== dataSrc) {
          video.src = dataSrc;
          video.load();
        }

        if (!shouldPlayVideo) {
          video.pause();
          return;
        }

        if (video.getAttribute("src")) {
          requestSlideshowVideoPlay(video);
        }
      });
    };
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      slidesPerGroup: slidesPerGroup,
      spaceBetween: spacingMobile ? spacingMobile : spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: enableLoop,
      effect: effect,
      speed: speed,
      freeMode: freeMode
        ? {
            enabled: true,
            momentum: true,
            sticky: false,
          }
        : false,
      grabCursor: grabCursor,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      mousewheel: mouseWheel
        ? {
            forceToAxis: true,
            releaseOnEdges: true,
          }
        : false,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: _this.querySelector(".swiper-button-next") || document.querySelector(".swiper-personalized-next"),
        prevEl: _this.querySelector(".swiper-button-prev") || document.querySelector(".swiper-personalized-prev")
      },
      pagination: {
        clickable: true,
        el: typeSlide == 'shopable-video' ? _this.querySelector(".swiper-pagination-shopable-video") : _this.querySelector(".swiper-pagination"),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function () {
          var sec__tiktok = _this.closest(".sec__tiktok-video");
          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener("resize", function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
          var video = _this.querySelector("video.slideshow")
          if(video){
            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting) return;
              observer.unobserve(_this);
              syncSlideshowVideos();
              requestAnimationFrame(syncSlideshowVideos);
              setTimeout(syncSlideshowVideos, 150);
              window.addEventListener("resize", syncSlideshowVideos);
            };
            new IntersectionObserver(handleIntersection.bind(_this), {
              rootMargin: "0px 0px 200px 0px",
            }).observe(_this);
          }
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.querySelector("video.slideshow")) {
            requestAnimationFrame(syncSlideshowVideos);
          }
          if (_this.closest(".sec__testimonials-single")) {
            const allDots = _this
              .closest(".sec__testimonials-single")
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove("active");
            });
            _this
              .closest(".sec__testimonials-single")
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']"
              )
              .classList.add("active");
          }
        },
      },
    });
  }

  functionGoto(position) {
    this.globalSlide.slideTo(position - 1, 500);
  }

  initSecTiktok(sec) {
    sec.querySelectorAll(".swiper-slide").forEach((arrow) => {
      const tiktok = arrow.querySelector(".section_tiktok-image");
      let width = "--item-width: " + arrow.offsetWidth;
      tiktok.setAttribute("style", width);
    });
  }
}
customElements.define("slide-section", SlideSection);

class PopupBase extends HTMLElement {
  constructor() {
    super();
    this.customClass = this.dataset.customClass;
    this.modal = null;
  }

  initPopup(content, text, customClass) {
    const _this = this;
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      cssClass: [this.customClass || customClass],
      onOpen: function () {
        const video = this.modalBox.querySelector("video");
        if (!video) return;
        video.play();
        const shopableVideoItem = this.modalBox.querySelector('.wrapper-content-append');
        if (!shopableVideoItem) return;
        fetch(shopableVideoItem.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const htmlQuickview = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector(
              '#shopify-section-product-quickview .product-quickview__content .append-js'
            );
          shopableVideoItem.innerHTML = htmlQuickview.innerHTML;
        })
        .finally(() => {
          Shopify.PaymentButton.init();
        })
        .catch((e) => {
          console.error(e);
        });
        const productPopupDiv = this.modalBox.querySelector('.video-item__product-mobile');
        if (productPopupDiv) {
          productPopupDiv.addEventListener(
            'click',
            () => {
              const productInformation = this.modalBox.querySelector(
                '.shopable-video__product-information'
              );
              if (!productInformation) return;
              productInformation.classList.toggle('hidden');
            }
          );
        }
      },
      onClose: function () {},
      beforeClose: function () {
        _this.onCloseEvent();
        return true;
      },
    });
    this.modal.setHeader = function (content) {
      let popup_content = this.modalBoxContent;
      let popup_header = document.createElement("div");
      popup_header.classList.add("tingle-modal-box__header");
      popup_header.innerHTML = content;
      let parentElement = popup_content.parentNode;
      parentElement.insertBefore(popup_header, popup_content);
    };
    if (text) {
      this.modal.setHeader(text);
    }

    this.modal.setContent(content);
    this.modal.open();
  }

  onClose() {
    this.modal.close();
  }
  onCloseEvent() {}
}

class SwatchInit extends HTMLElement {
  constructor() {
    super();
    this.options = null;
    this.init();
  }

  init() {
    const _this = this;
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      _this.checkSwatches(btn);
    });
  }
  checkSwatches(e) {
    const { color, image, customValue, swatchType, optionSwatchValue } = e.dataset;
    if (color) {
      const swatchStyle = e.querySelector(".option-style");
      if (swatchType != "variant_images") {
        if (optionSwatchValue.length == 0 || optionSwatchValue == null) {
          if (swatchStyle != null) {
            if (this.checkColor(color)) {
              swatchStyle.style.backgroundColor = color;
              swatchStyle.classList.add(customValue);
            } else {
              swatchStyle.classList.add(customValue);
              if (image) {
                swatchStyle.classList.add("color__" + color.replace(" ", "-"));
                swatchStyle.style.backgroundColor = null;
                swatchStyle.style.backgroundImage = "url('" + image + "')";
                swatchStyle.style.backgroundSize = "cover";
                swatchStyle.style.backgroundRepeat = "no-repeat";
              }
            }
          }else{
            if (this.checkColor(color)) {
              e.style.backgroundColor = color;
              e.classList.add(customValue);
            } else {
              e.classList.add(customValue);
              if (image) {
                e.classList.add("color__" + color.replace(/\s+/g, "-").replace(/\+/g, "-"));
                e.style.backgroundColor = null;
                e.style.backgroundImage = "url('" + image + "')";
                e.style.backgroundSize = "cover";
                e.style.backgroundRepeat = "no-repeat";
              }
            }
          }
        }else{
          e.style.setProperty('--swatch--background', optionSwatchValue);
        }  
      } else {
        if (optionSwatchValue.length == 0 || optionSwatchValue == null) {
          if (image) {
            e.classList.add("color__" + color.replace(/\s+/g, "-").replace(/\+/g, "-"));
            e.style.backgroundColor = null;
            e.style.backgroundImage = "url('" + image + "')";
            e.style.backgroundSize = "cover";
            e.style.backgroundRepeat = "no-repeat";
          } else if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
          }
        }else{
          e.style.setProperty('--swatch--background', optionSwatchValue);
        }
      }
    }
  }
  checkColor(strColor) {
    var s = new Option().style;
    s.color = strColor;
    return s.color == strColor;
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(".product__color-swatches--js.active"),
      (select) => select.getAttribute("data-value")
    );
    this.variantData.find((variant) => {
      if (this.options.length == 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        };
        if (variantOptions[this.position_swatch] === this.options[0]) {
          this.options = variant.options;
        }
      }
    });
  }
  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    }));
  }

  async resolveWithCascade({
    resolveVariant,
    cascadeFallback,
    refreshAfterCascade,
    allowCascade = true
  } = {}) {
    if (!this.currentVariant && typeof resolveVariant === 'function') {
      await resolveVariant();
    }

    const cascaded =
      allowCascade && typeof cascadeFallback === 'function'
        ? await cascadeFallback()
        : false;

    if (cascaded && typeof refreshAfterCascade === 'function') {
      await refreshAfterCascade();
    }

    return {
      cascaded,
      hasVariant: !!this.currentVariant
    };
  }
}

// js for 3d product - not done yet
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        deferredElement.play();
      }
    }
  }
}

function handleErrorMessagePopup(errorMessage = false) {
  const url = `${window.location.pathname}?section_id=form-message`;
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const elementErrorMessage = html.querySelector(
        ".product-form__error-message-wrapper"
      );
      const elementMessage = elementErrorMessage.querySelector(
        ".product-form__error-message"
      );
      elementMessage.textContent = errorMessage;
      showToast(elementErrorMessage.innerHTML, 5000, "modal-error");
    })
    .catch((e) => {
      throw e;
    });
}

function showToast(
  message,
  duration = 3000,
  customClass = "",
  anchorElement = null,
  positionOptions = null
) {
  let toastContainer = document.getElementById("toast-container");
  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.id = "toast-container";
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement("div");
  toast.className = `toast show ${customClass}`;
  toast.innerHTML = message;
  toastContainer.appendChild(toast);
  if (anchorElement instanceof Element) {
    positionToastNearAnchor(toast, anchorElement, positionOptions || {});
    syncToastWithMovingAnchor(
      toast,
      anchorElement,
      positionOptions || {}
    );
  }

  toast.toastAutoCloseTimer = setTimeout(() => {
    closeToast(toast);
  }, duration);
  return toast;
}

function positionToastNearAnchor(toast, anchorElement, options = {}) {
  const placement = options.placement || "top";
  if (placement === "right") {
    positionToastRightOfAnchor(toast, anchorElement, options);
    return;
  }
  positionToastAboveAnchor(toast, anchorElement, options);
}

function positionToastAboveAnchor(toast, anchorElement, options = {}) {
  const anchorRect = anchorElement.getBoundingClientRect();
  const toastRect = toast.getBoundingClientRect();
  const viewportPadding = 8;
  const offsetY = Number.isFinite(options.offsetY) ? options.offsetY : 10;
  let top = anchorRect.top - toastRect.height - offsetY;
  let left = anchorRect.left + anchorRect.width / 2;
  const minTop = viewportPadding;
  const maxTop = Math.max(
    minTop,
    window.innerHeight - viewportPadding - toastRect.height
  );
  const minCenterX = viewportPadding + toastRect.width / 2;
  const maxCenterX = window.innerWidth - viewportPadding - toastRect.width / 2;

  if (top < viewportPadding) {
    top = anchorRect.bottom + offsetY;
  }
  top = Math.max(minTop, Math.min(maxTop, top));
  left = Math.max(minCenterX, Math.min(maxCenterX, left));

  toast.style.top = `${top}px`;
  toast.style.left = `${left}px`;
  toast.style.right = "auto";
  toast.style.marginLeft = "0";
  toast.style.transform = "translateX(-50%)";
}

function positionToastRightOfAnchor(toast, anchorElement, options = {}) {
  const anchorRect = anchorElement.getBoundingClientRect();
  const toastRect = toast.getBoundingClientRect();
  const viewportPadding = 8;
  const offsetX = Number.isFinite(options.offsetX) ? options.offsetX : 12;
  const offsetY = Number.isFinite(options.offsetY) ? options.offsetY : 0;

  let top = anchorRect.top + anchorRect.height / 2 + offsetY;
  const minCenterY = viewportPadding + toastRect.height / 2;
  const maxCenterY = window.innerHeight - viewportPadding - toastRect.height / 2;
  top = Math.max(minCenterY, Math.min(maxCenterY, top));

  let left = anchorRect.right + offsetX + toastRect.width / 2;
  const minCenterX = viewportPadding + toastRect.width / 2;
  const maxCenterX = window.innerWidth - viewportPadding - toastRect.width / 2;
  left = Math.max(minCenterX, Math.min(maxCenterX, left));

  toast.style.top = `${top}px`;
  toast.style.left = `${left}px`;
  toast.style.right = "auto";
  toast.style.marginLeft = "0";
  toast.style.transform = "translate(-50%, -50%)";
}

function closeToast(toast) {
  if (!(toast instanceof Element)) return;
  if (toast.dataset.toastClosing === "true") return;

  toast.dataset.toastClosing = "true";
  if (toast.toastAutoCloseTimer) {
    clearTimeout(toast.toastAutoCloseTimer);
    toast.toastAutoCloseTimer = null;
  }
  toast.classList.remove("show");
  setTimeout(() => {
    if (toast.isConnected) {
      toast.remove();
    }
    const toastContainer = document.getElementById("toast-container");
    if (toastContainer && !toastContainer.querySelector(".toast")) {
      toastContainer.remove();
    }
  }, 500);
}

function syncToastWithMovingAnchor(
  toast,
  anchorElement,
  positionOptions = {}
) {
  // Cart addon panels can animate/collapse right after success requests.
  // Re-position anchored toasts for a short window so they stay attached.
  const followUpDelays = [120, 260, 420];
  for (const delay of followUpDelays) {
    setTimeout(() => {
      if (!(toast instanceof Element) || !toast.isConnected) return;
      if (!(anchorElement instanceof Element) || !anchorElement.isConnected) return;

      positionToastNearAnchor(toast, anchorElement, positionOptions);
    }, delay);
  }
}

class SlideLazyLoad {
  constructor(e) {
    (this.triggerEventsJs = e), (this.eventOptionsJs = { passive: !0 }), (this.userEventListenerJs = this.triggerListenerJs.bind(this)), (this.delayedScriptsJs = { normal: [], async: [], defer: [] });
  }
  triggerListenerJs() {
      this._removeUserInteractionListenerJs(this), "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", this._loadEverythingReadyNow.bind(this)) : this._loadEverythingReadyNow();
  }
  _removeUserInteractionListenerJs(e) {
      this.triggerEventsJs.forEach((t) => window.removeEventListener(t, e.userEventListenerJs, e.eventOptionsJs));
  }
  _addUserInteractionListenerJs(e) {
      this.triggerEventsJs.forEach((t) => window.addEventListener(t, e.userEventListenerJs, e.eventOptionsJs));
  }
  _preloadAllScriptsJs() {
    document.body.classList.add("swiper-lazy");
    document.body.classList.add("review-lazy");
    const loadingSwiper = document.querySelectorAll('.lazy-loading-swiper-after');
    loadingSwiper.forEach((el) => {
      el.classList.remove("lazy-loading-swiper-after");
      this.initSlide(el);
    });
    const reviewProduct = document.querySelectorAll('.review-product-added');
    reviewProduct.forEach((el) => {
      el.classList.remove("review-product-added");
      el.innerHTML = el.querySelector(".product-review-json").innerHTML;
      el.classList.remove("inline-loading");
    });
    
    const productMarqueeBadges = document.querySelectorAll('.product__marquee-badges');
    productMarqueeBadges.forEach((el) => {
      if (el.querySelector("template")) {
        const content = document.createElement("div");
        content.appendChild(
          el.querySelector("template").content.firstElementChild.cloneNode(true)
        );
        const animationMarquee = content.querySelectorAll('.animation-marquee');
        animationMarquee.forEach((el_animation) => {
          el.appendChild(el_animation);
        });
        el.querySelector("template").remove();
      }
    });

    const menuList = document.querySelectorAll('.menu-list');
    menuList.forEach((el) => {
      if (el.querySelector("template")) {
        const content = document.createElement("div");
        content.appendChild(
          el.querySelector("template").content.firstElementChild.cloneNode(true)
        );
        el.appendChild(content.querySelector('.subchildmenu'));
        el.querySelector("template").remove();
      }
    });
    const submenuList = document.querySelectorAll('.submenu');
    submenuList.forEach((el) => {
      if (el.querySelector("template")) {
        const content = document.createElement("div");
        content.appendChild(
          el.querySelector("template").content.firstElementChild.cloneNode(true)
        );
        el.appendChild(content.querySelector('.subchildmenu'));
        el.querySelector("template").remove();
      }
    });

    const shopableVideoOptimize = document.querySelectorAll('.shopable-video-optimize');
    shopableVideoOptimize.forEach((el) => {
      if (el.querySelector("template")) {
        const content = document.createElement("div");
        content.appendChild(
          el.querySelector("template").content.firstElementChild.cloneNode(true)
        );
        el.appendChild(content.querySelector('.video-item__popup'));
        el.querySelector("template").remove();
      }
    });

   const video = document.querySelectorAll("video");
    video.forEach((el) => {
      if (el.closest('.shopable-video-optimize')) {
        const videoSrcset = el.dataset.src;
        if (videoSrcset) {
            el.setAttribute("src", videoSrcset);
            el.removeAttribute("data-src");
        }
      }
    });

    const lazyImage = document.querySelectorAll(".image-lazy-load.optimize");
    lazyImage.forEach((el) => {
      const imgSrcset = el.dataset.srcset;
      if (imgSrcset) {
          el.setAttribute("srcset", imgSrcset);
          el.removeAttribute("data-srcset");
          el.classList.remove("image-lazy-load");
          el.classList.add("image-lazy-loaded");
      }
    });


    const recommend = document.querySelector('.predictive-search')
    if (recommend && recommend.querySelector("template")) {
      const content = document.createElement("div");
      content.appendChild(
        recommend.querySelector("template").content.firstElementChild.cloneNode(true)
      );
      recommend.appendChild(content.querySelector(".search-list-item"));
      recommend.querySelector("template").remove();
    }
  }

  initSlide(el) {
    const _this = el;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    const totalSlides = countSwiperSlides(_this);
    const enableLoop =
      loop &&
      canUseSwiperLoop(
        totalSlides,
        [
          {
            slidesPerView: autoItem ? "auto" : itemMobile,
          },
          {
            slidesPerView: itemTablet,
          },
          {
            slidesPerView: itemDesktop,
          },
        ],
        row
      );
    const requestSlideshowVideoPlay = (video) => {
      const playVideo = () => {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.play().catch(() => {});
      };

      if (video.readyState >= 2) {
        playVideo();
        return;
      }

      video.addEventListener("loadeddata", playVideo, { once: true });
      video.addEventListener("canplay", playVideo, { once: true });
    };
    const syncSlideshowVideos = () => {
      const videos = _this.querySelectorAll("video.slideshow");
      const isMobileViewport = window.innerWidth <= 767;
      const activeSlide = _this.querySelector(".swiper-slide-active");
      const firstSlide = _this.querySelector(".swiper-slide");
      videos.forEach((video) => {
        const posterDesktop = video.dataset.posterdesktop;
        const posterMobile = video.dataset.postermobile;
        const mediaTarget = video.dataset.mediaTarget;
        const slide = video.closest(".swiper-slide");
        const shouldLoadVideo =
          !mediaTarget ||
          (isMobileViewport ? mediaTarget === "mobile" : mediaTarget === "desktop");
        const shouldPlayVideo =
          shouldLoadVideo &&
          (!slide ||
            slide.classList.contains("swiper-slide-active") ||
            (!activeSlide && firstSlide && slide === firstSlide));

        if (posterDesktop && posterMobile) {
          video.poster = isMobileViewport ? posterMobile : posterDesktop;
        }

        if (!shouldLoadVideo) {
          video.pause();
          return;
        }

        const dataSrc = video.dataset.src;
        if (dataSrc && video.getAttribute("src") !== dataSrc) {
          video.src = dataSrc;
          video.load();
        }

        if (!shouldPlayVideo) {
          video.pause();
          return;
        }

        if (video.getAttribute("src")) {
          requestSlideshowVideoPlay(video);
        }
      });
    };
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: enableLoop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: _this.querySelector(".swiper-button-next"),
        prevEl: _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: _this.querySelector(".swiper-pagination"),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function () {
          var sec__tiktok = _this.closest(".sec__tiktok-video");
          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener("resize", function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
          if (_this.querySelector("video.slideshow")) {
            syncSlideshowVideos();
            requestAnimationFrame(syncSlideshowVideos);
            setTimeout(syncSlideshowVideos, 150);
            window.addEventListener("resize", syncSlideshowVideos);
          }
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.querySelector("video.slideshow")) {
            requestAnimationFrame(syncSlideshowVideos);
          }
          if (_this.closest(".sec__testimonials-single")) {
            const allDots = _this
              .closest(".sec__testimonials-single")
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove("active");
            });
            _this
              .closest(".sec__testimonials-single")
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']"
              )
              .classList.add("active");
          }
        },
      },
    });
  }

  async _loadEverythingReadyNow() {
    this._preloadAllScriptsJs(),
    await this._loadScriptsFromListJs(this.delayedScriptsJs.normal),
    await this._loadScriptsFromListJs(this.delayedScriptsJs.defer),
    await this._loadScriptsFromListJs(this.delayedScriptsJs.async),
    await this._triggerDOMContentLoadedJs(),
    await this._triggerWindowLoadJs(),
    window.dispatchEvent(new Event("glozinspeed-allScriptsLoaded"));
  }
  async _loadScriptsFromListJs(e) {
    const t = e.shift();
    return t ? (await this._transformScript(t), this._loadScriptsFromListJs(e)) : Promise.resolve();
  }
  async _transformScript(e) {
    return (
        await this._requestAnimFrame(),
        new Promise((t) => {
            const s = document.createElement("script");
            let n;
            [...e.attributes].forEach((e) => {
                let t = e.nodeName;
                "type" !== t && ("data-glozinlazy-type" === t && ((t = "type"), (n = e.nodeValue)), s.setAttribute(t, e.nodeValue));
            }),
                e.hasAttribute("src") ? (s.addEventListener("load", t), s.addEventListener("error", t)) : ((s.text = e.text), t()),
                e.parentNode.replaceChild(s, e);
        })
    );
  }
  async _triggerDOMContentLoadedJs() {
    (this.domReadyFired = !0),
    await this._requestAnimFrame(),
    document.dispatchEvent(new Event("glozinspeed-DOMContentLoaded")),
    await this._requestAnimFrame(),
    window.dispatchEvent(new Event("glozinspeed-DOMContentLoaded")),
    await this._requestAnimFrame(),
    document.dispatchEvent(new Event("glozinspeed-readystatechange")),
    await this._requestAnimFrame(),
    document.glozinonreadystatechange && document.glozinonreadystatechange();
  }
  async _triggerWindowLoadJs() {
    await this._requestAnimFrame(),
    window.dispatchEvent(new Event("glozinspeed-load")),
    await this._requestAnimFrame(),
    window.glozinonload && window.glozinonload(),
    await this._requestAnimFrame(),
    window.dispatchEvent(new Event("glozinspeed-pageshow")),
    await this._requestAnimFrame(),
    window.glozinonpageshow && window.glozinonpageshow();
  }
  async _requestAnimFrame() {
    return new Promise((e) => requestAnimationFrame(e));
  }
  static run() {
    const e = new SlideLazyLoad(["keydown", "mousemove", "touchmove", "touchstart", "touchend", "wheel"]);
    e._addUserInteractionListenerJs(e);
  }
}
SlideLazyLoad.run();

// js for copy button
class CopyButton extends HTMLElement {
  constructor() {
    super();
    this.content = this.dataset.content;
    this.init();
  }
  init() {
    if (this.content) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    navigator.clipboard.writeText(this.content);
    this.classList.add("copied");
  }
  updateUrl(newContent) {
    this.content = newContent;
  }
}
customElements.define("copy-button", CopyButton);


var BlsLazyloadImg = (function () {
  return {
    init: function () {
      this.lazyReady();
    },
    lazyReady: function () {
      if (!!window.IntersectionObserver) {
        let observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const onImageLoad = (e) => {
                  const target = e.currentTarget;
                  setTimeout(() => {
                    target
                      ?.closest("motion-element")
                      ?.classList.remove("bls-loading-image");
                    target?.classList.remove("bls-loading-image");
                  }, 600);
                  e.currentTarget.removeEventListener("load", onImageLoad);
                };
                entry.target.width = entry.boundingClientRect.width;
                entry.target.height = entry.boundingClientRect.height;
                entry.target.sizes = `${entry.boundingClientRect.width}px`;
                entry.target.addEventListener("load", onImageLoad);
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: "10px" }
        );
        document.querySelectorAll(".bls-image-js img").forEach((img) => {
          observer.observe(img);
        });
      }
    },
  };
})();
BlsLazyloadImg.init();
